module.exports = __webpack_public_path__ + "img/pescado.9c625aeb.png";